/**
 * @Name：
 * @Author：syy
 * @description：
 */
export const setter = {
  //baseURL: 'http://axs.hljcy.cn',
  // baseURL: 'http://219.147.85.239:2233',
  // baseURL: 'http://197.77.77.203:2233',
  baseURL:'https://xcx.anxinsu.com',
  interceptor: false, //是否开启未登入拦截
  //自定义请求字段
  request: {
	  // application:"app",
	  // application_client_type:"app",
	  // token:"03eaffb9728b229f300d96642ab45ba8",
	  // ajax:"ajax",
    tokenName: 'token' //自动携带 token 的字段名。可设置 false 不携带。
  },
  //自定义响应字段
  response: {
    statusName: 'errorCode', //数据状态的字段名称
    statusCode: {
      ok: 0  //数据状态一切正常的状态码
    },
    msgName: 'msg', //状态信息的字段名称
    dataName: 'result' //数据详情的字段名称
  },
  entryPage: '/', //登录后进入的页面
  header: {
    background: 'transparent',
    hide: ['/'], // 隐藏头部的路由列表
    left: {
      isShow: true, // 是否显示左侧图标
      icon: '', // 左侧图标，默认arrow-left
      color: '#fff', // 左侧图标颜色，默认#333
      hide: [] // 隐藏头部左侧按钮的路由列表
    },
    right: {
      isShow: true, // 是否显示右侧图标
      icon: '', // 右侧图标，默认question-o
      color: '', // 右侧图标颜色，默认#333
      hide: [] // 隐藏头部右侧按钮的路由列表
    }
  },
  footer: {
    isShow: true, // 是否显示footer
    background: '#fff', // 背景颜色
    activeColor: '', // 被选中图标的颜色
    menu: [
      /* {
         color : '#333', //字体和图标颜色
         icon : '', // 图标，默认
         fontSize : '', // 字号，默认
         router: '/notice' //
       }*/
    ]
  }
};
